import { FC } from 'react';

const NoRefinedSugarsIcon: FC = () => {
  return (
    <svg
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.334 65.625C52.2477 65.625 65.959 51.9137 65.959 35C65.959 18.0863 52.2477 4.375 35.334 4.375C18.4203 4.375 4.70898 18.0863 4.70898 35C4.70898 51.9137 18.4203 65.625 35.334 65.625Z"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M51.668 52.5L56.1888 57.3125"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.625 12.834L20.3125 18.959"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M49.626 49L39.5635 53.9583V41.7083L49.626 36.75V49Z"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3545 49L39.5628 53.9583V41.7083L29.3545 36.75V49Z"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.6253 36.4583L39.5628 31.5L29.3545 36.4583"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.542 33.3958V27.2708L55.6045 22.3125V34.5625L49.3337 37.625"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5423 33.6868V27.1243L35.334 22.166V32.2285"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.6048 21.8743L45.5423 16.916L35.334 22.0202"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1885 42.875L25.126 44.3333V32.0833L35.3343 27.125V32.0833"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0635 39.375L25.126 44.3333V32.0833L15.0635 27.125V39.375Z"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3343 26.8333L25.126 21.875L15.0635 26.9792"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoRefinedSugarsIcon;
